import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment/moment';
import { getCountDisplayedValue } from '@shared/utils';

@Pipe({name: 'formattedCount', pure: true})
export class FormattedCountPipe implements PipeTransform {
  transform(value: number, maxNumber?: number): string {
    return getCountDisplayedValue(value, maxNumber);
  }
}
